import React from 'react';
import PropTypes from 'prop-types';

/**
 * Renders a button that calls the provided clickHandler when clicked.
 */
const ActionButton = ({ children, clickHandler, className, disabled, tabIndex }) => {
  let classList = 'base-button';

  if (className) {
    classList += ` ${className}`;
  }

  return (
    <button
      className={classList}
      onClick={clickHandler}
      disabled={disabled}
      tabIndex={tabIndex}
    >
      {children}
    </button>
  );
}

ActionButton.propTypes = {
  /**
   * the callback function for when the button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
  /**
   * additional classes to add to the button
   */
  className: PropTypes.string,
  /**
   * whether or not the button should be visually disabled and unable to be clicked
   */
  disabled: PropTypes.bool,
  /**
   * the tabindex for the button
   */
  tabIndex: PropTypes.number,
};

ActionButton.defaultProps = {
  disabled: false,
  tabIndex: 0,
};

export default ActionButton;
